import { ID } from '../../utils/codecUtils';
import { RawSchema } from '../models/rawSchema';
import { rawSchemaSchema } from '../models/rawSchema.schema';
import { Schema } from '../models/schema';
import { schemaSchema } from '../models/schema.schema';
import { patchSchemaPayloadSchema } from './patch.schema';

export type PatchSchemaPayload = Partial<Schema>;
export type PatchRawSchemaPayload = Partial<RawSchema>;

export const patch = (schemaId: ID, payload: PatchSchemaPayload) => {
  return {
    endpoint: `/schemas/${schemaId}`,
    method: 'PATCH',
    responseSchema: schemaSchema,
    payloadSchema: patchSchemaPayloadSchema,
    payload,
  } as const;
};

export const patchRaw = (schemaId: ID, payload: PatchRawSchemaPayload) => {
  return {
    endpoint: `/schemas/${schemaId}`,
    method: 'PATCH',
    responseSchema: rawSchemaSchema,
    payloadSchema: rawSchemaSchema.partial(),
    payload,
  } as const;
};
